import { HttpClient } from '@angular/common/http';
import { inject, Injectable, isDevMode } from '@angular/core';

import { differenceInMinutes } from 'date-fns';
import { environment } from 'projects/semeris/src/environments/environment';
import { timer } from 'rxjs';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private readonly http = inject(HttpClient);

  private readonly intervalInMs = 5 * 60_000;
  private readonly snoozeInMinutes = 60;

  public init() {
    timer(5_000, this.intervalInMs).subscribe(() => {
      this.checkForUpdate();
    });
  }

  public checkForUpdate() {
    const snoozedAt = LocalStorageService.get<string>(`version-update-snoozed-at`);

    const difference = Math.abs(differenceInMinutes(new Date(), new Date(snoozedAt)));

    if (difference < this.snoozeInMinutes) {
      return;
    }

    this.http
      .get<{
        version: string;
      }>(`/assets/version.json?rnd=${Date.now()}`)
      .subscribe(
        (response) => {
          if (!response) {
            console.error('Failed to check for update.');
            return;
          }

          if (response?.version !== environment.version && !isDevMode()) {
            this.sendUpdateNotification();
          }
        },
        (err) => {
          console.error('Failed to check for update.');
          console.error(err);
        }
      );
  }

  public sendUpdateNotification() {
    // nosemgrep: javascript-confirm -- intentional user prompt
    const confirmed = confirm(
      'Semeris Docs update available. Click OK to reload the new version. You snooze the update by clicking Cancel.'
    );

    if (confirmed) {
      window.location.reload();
    } else {
      LocalStorageService.set(new Date().toISOString(), `version-update-snoozed-at`);
    }
  }

  public hardReset() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }
}
